module.exports = __webpack_public_path__ + "static/media/telecommunications.9bb0823d.png";